<template>
  <div>
    <!--Header-->
    <div class="header bg-green pt-5 pb-4">
      <b-container >
        <b-row align-v="center">
         
          <b-col lg="8" >
            <div class="pr-5">
              <h1 style="padding-top:58px" class="display-3 text-white font-weight-bold mb-0">您的AI智能交易助手</h1>
              
              <h2 style="padding-top:30px" class="display-4 text-white font-weight-light">高性能计算 AI策略引擎</h2>
              <!-- <h2 style="margin-top:-5px" class="display-4 text-white font-weight-light">用聊天的方式表达 帮您生成策略程序代码</h2> -->

              <h2 style="margin-top:-5px" class="display-4 text-white font-weight-light">智能生成 云端执行 即时提醒</h2>
              <h2 style="margin-top:-5px" class="display-4 text-white font-weight-light">精选AI策略分享，共同学习交流</h2>
               <!-- <p class="text-white mt-4">您的AI交易助手.</p>  -->
            </div>
          </b-col>
           <b-col lg="4" >
              <img class="bannerImg" src="/img/Unknown.png"/>
          </b-col>
        </b-row>
      </b-container>
    </div>

   <b-container style="margin-top:25px;" class="content-box-2">
    <b-row align-v="center" >
        <b-col lg="3">
            <div class="wrap">           
              <p class="stripe-main__title">AI-策略引擎</p>
              <p class="stripe-main__tip">聊天即生成策略</p>

            </div>
          </b-col>


          <b-col lg="3">
            <div class="wrap">           
              <p class="stripe-main__title">AI-股市问诊</p>
              <p class="stripe-main__tip">多维度、立体化分析</p>

            </div>
          </b-col>

          <b-col lg="3">
            <div class="wrap">           
              <p class="stripe-main__title">AI-趋势分析</p>
              <p class="stripe-main__tip">主动发现板块热点</p>

            </div>
          </b-col>

        
        
          <b-col lg="3">
            <div class="">           
              <p class="stripe-main__title">AI-策略精选</p>
              <p class="stripe-main__tip">Transformer AI大模型</p>

            </div>
          </b-col>

         

        </b-row>

       
    </b-container>
   
    <div class="dis20"></div>
    <b-container class="content-box-3">
      <div class="col-sm-12 text-center">
          <h2 class="no_margin">
            聊天的方式 生成策略
          </h2>
          <div class="dis10"></div>
          <p class="no_margin1">如：请帮忙生成一个文华指标，30日均线金叉做多，死叉平仓。</p>
      </div>
      <div class="dis5"></div>
      <div class="relative w-full" style="min-height: 118px;">
        <div class="SearchCopilot_searchContainer__K9SFC" style="position: absolute;">
          <textarea v-model="chatContent" class="SearchCopilot_textarea__EPaA1" rows="4" placeholder="您的交易思路是什么？请随便说，我都会竭尽所能为您分析，并生成代码。"></textarea>
          <div class="SearchCopilot_bottomContainer__mwLV3">
            <div></div>
            <div class="SearchCopilot_quickRight__FszXa">
               <a @click="onChatBtnClicked()" class="btn"><span class="" data-state="closed">
                  <svg width="32" height="32" viewBox="0 0 24 24" fill="none" class="text-white dark:text-black" style="margin-left:-5px;margin-top:-2px">
                    <path d="M7 11L12 6L17 11M12 18V7" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"></path>
                  </svg>
                  </span></a>
            </div>
          </div>
        </div>
      </div>

     </b-container>

    
    
     <b-container class="content-box-3">
      <div class="dis20"></div>
    <div class="dis20"></div>
      <div class="dis20"></div>
      <div class="col-sm-12 text-center">
          <h2 class="no_margin">
            全平台随时随地待命
          </h2>
          <div class="dis10"></div>
          <p class="no_margin1">为您的 <strong>量化交易研究</strong> 提供助力</p>
      </div>
      <!-- <div class="dis40"></div> -->
      <div class="xm_app_intro__inner">
        <b-row align-v="center" >
        <b-col lg="4">
        <div class="xm_app_intro__img">
            <img src="/img/mobile.png" alt="" class="img-responsive center-block xmapp_iso" width="455">
        </div>
        </b-col>
        <b-col lg="8">
        <div class="xm_app_intro_desc">
          <div class="dis40 hidden-xs"></div>
            <div class="dis50 visible-md visible-lg"></div>
              <div class="hidden-xs">
                <div class="xm_app_intro-list">
                    <i class="" ><img class="home-icon" src="/img/icon_chat.webp" /></i>
                    <ul>
                        <li><h3>可生成主流量化平台策略代码</h3></li>
                        <li>
                            
                                支持主流的量化语言，如文华、盘立方、同花顺、开拓者、MT4/MT5等；
                                
                        </li>
                    </ul>
                </div>
                <hr>
                <div class="xm_app_intro-list">
                    <i class="" ><img class="home-icon" src="/img/icon_trade.webp" /></i>
                    <ul>
                        <li><h3>AI云端回测</h3></li>
                        <li>策略代码一键云端回测分析；</li>
                    </ul>
                    <!-- <ul>
                        <li><h3>提供最新、最全历史数据，AI帮您回测分析</h3></li>
                        <li>覆盖商品期货、沪深股市、港股、美股等历史市场；</li>
                    </ul> -->
                </div>
                <hr>
                <div class="xm_app_intro-list">
                    <i class="" ><img class="home-icon" src="/img/icon_ai.webp" /></i>
                    <ul>
                        <li><h3><strong>AI智能解读</strong></h3></li>
                        <li>帮助您优化策略、深度分析、解读策略；助你发现问题，解决问题；</li>
                    </ul>
                </div>
                <hr>
                <div class="xm_app_intro-list">
                    <i class="" ><img class="home-icon" src="/img/icon_platorm.webp" /></i>
                    <ul>
                        <li><h3><strong>全平台服务</strong> </h3></li>
                        <li>逐步推出Web网页、手机APP、微信小程序等平台；</li>
                    </ul>
                </div>
              </div>
        </div>
        </b-col>
        </b-row>
      </div>
    </b-container>
    <b-container class="content-box-3">
      <div class="dis20"></div>
      <div class="dis20"></div>
      <div class="col-sm-12 text-center" style="margin-bottom:30px">
          <h2 class="no_margin">
            AI解读市场 交易风向标
          </h2>
          <div class="dis10"></div>
          <p class="no_margin1" >投资有风险，入市需谨慎，此观点仅代表AI策略输出</p>
      </div>
      <div class="fee-nav-list">
        <!-- <a  @click="longShortCategory(7)" :class="['fee-nav-list-item', { 'fee-nav-list-item-active': longShortKind==7 }]">股指</a>
        <a  @click="longShortCategory(1)" :class="['fee-nav-list-item', { 'fee-nav-list-item-active': longShortKind==1 }]">贵金属/有色</a>
        <a  @click="longShortCategory(2)" :class="['fee-nav-list-item', { 'fee-nav-list-item-active': longShortKind==2 }]">能源</a>
        <a  @click="longShortCategory(3)" :class="['fee-nav-list-item', { 'fee-nav-list-item-active': longShortKind==3 }]">黑色/煤炭</a>
        <a  @click="longShortCategory(4)" :class="['fee-nav-list-item', { 'fee-nav-list-item-active': longShortKind==4 }]">化工/轻工</a>
        <a  @click="longShortCategory(5)" :class="['fee-nav-list-item', { 'fee-nav-list-item-active': longShortKind==5 }]">油脂油料</a>
        <a  @click="longShortCategory(6)" :class="['fee-nav-list-item', { 'fee-nav-list-item-active': longShortKind==6 }]">其它</a> -->

        <!-- <a  @click="longShortCategory(1)" :class="['fee-nav-list-item', { 'fee-nav-list-item-active': longShortKind==1 }]">期货</a> -->
        <a  @click="longShortCategory(1)" :class="['fee-nav-list-item', { 'fee-nav-list-item-active': longShortKind==1 }]">商品期货</a>
        <a  @click="longShortCategory(2)" :class="['fee-nav-list-item', { 'fee-nav-list-item-active': longShortKind==2 }]">A股</a>
        <!-- <a  @click="longShortCategory(3)" :class="['fee-nav-list-item', { 'fee-nav-list-item-active': longShortKind==3 }]">A股-地区板块</a> -->
        <!-- <a  @click="longShortCategory(3)" :class="['fee-nav-list-item', { 'fee-nav-list-item-active': longShortKind==3 }]">美股</a> -->
        
   </div>
<div class="dis20"></div>
      <div class="fee-module-body-card">
        <div class="fee-card fee-card-pc-home fee-card-small" v-for="row in longShorts"  >

          <div  class="fee-card-body">
            <div v-if="row.long_short==-1" class="fee-card-body-short">空头强势</div>
            <div v-if="row.long_short==1" class="fee-card-body-long">多头强势</div>
            <div v-if="row.long_short==0" class="fee-card-body-none">
              <span v-if="row.last_direction==1">震荡偏多</span>
              <span v-if="row.last_direction==-1">震荡偏空</span>
              <span v-if="row.last_direction==0">震荡区间</span>
            </div>
            
            <div >
              <div  class="fee-card-body-title fee-card-body-title-big">
                <div >{{ row.name }}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
       
    </b-container>

    <b-container class="content-box-3">
      <div class="dis20"></div>
      <div class="dis20"></div>
      <div class="col-sm-12 text-center" style="margin-bottom:30px">
          <h2 class="no_margin">
            精选AI策略分享
          </h2>
          <div class="dis10"></div>
          <p class="no_margin1">仅作为技术研究与交流，不构成任何投资建议</p>
      </div>

      <div class="equity-curriculum-container dark">
        <div class="equity" v-for="row in signalsData" >
          <div class="list">
            <p class="title demi">
              {{row.tags}} {{row.category_name}} {{row.name}} 
              <span v-if="row.signal_type == 'SwiftStorm' || row.signal_type == 'EverSteady'">
                <span v-if="row.buy_sell=='buy'" class="text-danger">买入</span>
                <span v-if="row.buy_sell=='sell'" class="text-success">卖出</span>
                
                <span style="margin-left:5px;" v-if="row.deal_type=='enterTrade'" class="text-danger">开仓</span>
                <span style="margin-left:5px;" v-if="row.deal_type=='exitTrade'" class="text-success">平仓</span>
              </span>
              <span v-if="row.signal_type == 'longShortResonance'">
                <span v-if="row.long_short==-1"  class="text-success">空头强势</span>
                <span v-if="row.long_short==1"  class="text-danger">多头强势</span>
                <span v-if="row.long_short==0 && row.last_direction==1" >震荡偏多</span>
                <span v-if="row.long_short==0 && row.last_direction==-1" >震荡偏空</span>
                <span v-if="row.long_short==0 && row.last_direction==0" >震荡区间</span>
              </span>
            </p>
            <p class="lectures" v-if="row.signal_type == 'SwiftStorm'">By AI策略-SwithStrom</p> 
            <p class="lectures" v-if="row.signal_type == 'EverSteady'">By AI策略-EverSteady </p> 
            <p class="lectures" v-if="row.signal_type == 'longShortResonance'">By AI-趋势分析 </p> 
            <p class="lectures1" >{{row.created_at}}</p> 

            <a v-if="row.signal_type == 'SwiftStorm'" href="/#/aishare/swithStrom" class="btn cmps-pc">详情</a>
            <a v-if="row.signal_type == 'EverSteady'" href="/#/aishare/everSteady" class="btn cmps-pc">详情</a>
            <a v-if="row.signal_type == 'longShortResonance'" href="/#/aishare/analysis" class="btn cmps-pc">详情</a>
           
          </div>
        </div>
      </div>
    </b-container>
  </div>
</template>
<script>
  import futureApi from "../../api/future";
  import stockApi from "../../api/stock";
  import { Tooltip } from 'element-ui'
  import swal from "sweetalert2";

  export default {
    name: 'home-page',
    components: {
      [Tooltip.name]: Tooltip
    },
    data() {
      return {
        longShortKind:"1",
        longShorts:[],
        signalsData:[],
        chatContent:"",
      }
    },
    methods: {
      async longShortCategory(val)
      {
        // console.log("longShortKind===>",val)
        this.longShortKind = val;
        this.getLongShort();
      },
      async getLongShort()
      {
        if(+this.longShortKind == 1)
        {
          const res = await futureApi.getIndustries({});
          if (res && res.code == 200) {
          
            const { data } = res;
            this.longShorts = data.industries;
            
            // console.log("---this.longShorts:===",data)
            // console.log("---longShorts:",this.futuresLongShort)
          }
        }
        else if(+this.longShortKind == 2)
        {
          
          const res = await stockApi.getCategories({deep:0});
          if (res && res.code == 200) {
          
            const { data } = res;
            this.longShorts = data.list;
            
            // console.log("---this.longShorts:===",data)
            // console.log("---longShorts:",this.futuresLongShort)
          }
        }

        
      },
      async getSignals()
      {
        let fromData1 = {
          signal_type:"all",
        }
        
        const res1 = await futureApi.getSignal(fromData1);
        // console.log("---res1:",res1)
        if (res1 && res1.code == 200) {
          
          const { data } = res1;
          this.signalsData = data.list;
        }
      },
      onChatBtnClicked()
      {
        localStorage.setItem('chatContent', this.chatContent);

        const userInfo = localStorage.getItem("userInfo");
        const authorization = localStorage.getItem('authorization')
        let isLogin = false;
        if(authorization != null && userInfo == null || userInfo == "" || userInfo == undefined)
        {
          isLogin = false;
        }else{
          const user = JSON.parse(userInfo);
          if(user && user.username != "" && user.username != null)
          {
            isLogin = true;
          }
        }

        if(isLogin)
        {
          window.location.href = "/#/AI";
        }else{
          swal
            .fire({
              title: `请先登陆！`,
              buttonsStyling: false,
              customClass: {
                confirmButton: "btn btn-success btn-fill",
              },
              confirmButtonText: "确定",
            })
            .then(function () {
              window.location.href = "/#/AI";
            });
        }
      },
      syncChatContent()
      {
        const savedString = localStorage.getItem('chatContent');
        if(savedString && savedString != null && savedString != "" && savedString != undefined)
        {
          this.chatContent = savedString;
        }
      }
    },
    
    mounted() {
      this.getLongShort();
      this.getSignals();
      this.syncChatContent();
    },
  };
</script>
<style>
.bannerImg
{
    margin-top: 3vw;
    margin-left: -8vw;
    /* min-width: 12vw; */
    width: 400px;
    /* width: 28vw; 
    height: 21vw; */
}

.content-box-2
{
    /* margin-top: 4vw;
    margin-left: -8vw;
    width: 28vw;
    height: 21vw; */
  text-align: center;
  background-color: #fff;
  /* height:138px; */
}

.content-box-3
{
  margin-top: 3.5vw;
  /*
    margin-left: -8vw;
    width: 28vw;
    height: 21vw; */
  text-align: center;
  /* background-color: #fff; */
  /* height:138px; */

  
}

.no_margin
{
  font-size: 28px;
}
.no_margin1
{
  font-size: 21px;
  line-height: 26px;
  color: #8d8d8d;
}

.center-block {
    float: none !important;
}
.center-block {
    display: block;
    margin-right: auto;
    margin-left: auto;
}
.img-responsive{
    display: block;
    max-width: 100%;
    height: auto;
}
.xmapp_iso {
    width: 445px;
}
.xm_app_intro__inner {
    display: flex;
    justify-content: center;
}
.xm_app_intro__img {
    width: 80%;
    margin-left: 10%;
    align-content: center;
    align-items: flex-start;
    display: flex;
}
/* .xm_app_intro_desc {
    width: 50%;
} */
.xm_app_intro-list {
    display: -webkit-box;
    display: -ms-flexbox;
    display: flex;
    -ms-flex-line-pack: top;
    align-content: center;
    -webkit-box-align: center;
    -ms-flex-align: top;
    align-items: flex-start;
    text-align: left;
    
}
.xm_app_intro-list li{
  list-style:none;
}

.dis40 {
    height: 40px;
    clear: both;
}
.dis30 {
    height: 30px;
    clear: both;
}
.dis20 {
    height: 20px;
    clear: both;
}
.dis5 {
    height: 5px;
    clear: both;
}
.xm_app_intro-list i {
    font-size: 32px;
}
.xm_app_intro-list h3 {
    font-size: 18px;
}


.stripe-main__title
{
  font-size: 30px;
  padding: 0 5px;

  color: #ff6900;
  text-transform: uppercase;
  font-family: "Bebas", "BebasExt", sans-serif;
  font-weight: 300;
  line-height: 1;
  margin-top: 35px;
}

.stripe-main__tip
{
  font-size: 24px;
  margin-top: -10px;

  color: #8d8d8d;
}

.wrap
{
  border-right: 1px solid #dddddd;
  margin-left: -18px;
}
.fa-kit {
    -moz-osx-font-smoothing: grayscale;
    -webkit-font-smoothing: antialiased;
    display: var(--fa-display, inline-block);
    font-variant: normal;
    text-rendering: auto;
    font-family: Font Awesome Kit;
    font-style: normal;
    line-height: 1;
}

.home-icon
{
  display: block;
  width: 50px;
}

hr {
    margin-top: 0.3rem;
    margin-bottom: 2rem;
    border: 0;
    border-top: 1px solid rgba(0, 0, 0, 0.1);
}

.equity-curriculum-container .equity {
    background: #fff;
    border: 1px solid rgba(0, 0, 0, 0);
    border-radius: 8px;
    margin-bottom: 20px;
    position: relative;
}
.equity-curriculum-container .equity .list {
    border-bottom: 0;
    cursor: pointer;
    padding: 24px 0 0;
}
.equity-curriculum-container .equity .list .title {
    font-size: 20px;
    line-height: 1.3;
    padding: 0 24px 0 25px;
    width: 90%;
    text-align: left;
}
.equity-curriculum-container .equity .list .lectures {
    font-size: 16px;
    padding: 0 24px 16px 25px;
    text-align: left;
    color: #999;
    margin-bottom: 0rem;
}

.equity-curriculum-container .equity .list .lectures1 {
    font-size: 14px;
    padding: 0 0px 0px 25px;
    text-align: left;
    color: #999;
    margin-top: -15px !important;
}

.equity-curriculum-container .equity .list .btn {
    background: #ff6900;
    border: 1px solid #ff6900;
    border-radius: 8px;
    color: #fff;
    font-size: 16px;
    /* height: 40px;
    line-height: 40px; */
    position: absolute;
    right: 24px;
    text-align: center;
    text-decoration: none;
    top: 75%;
    transform: translateY(-75%);
    width: 100px;
}

.fee-nav-list {
    display: flex;
    justify-content: space-between;
    border-bottom: 2px solid #bfbfbf;
    padding: 5px 20px 0px;
}
.fee-nav-list-item-active {
    border-bottom: 6px solid;
    color: #191b1e;
}

.fee-nav-list-item-active {
    border-bottom: 6px solid;
    color: #191b1e;
}

.fee-nav-list-item {
    height: 38px;
    box-sizing: content-box;
    padding: 0 5px;
    color: #9d9d9d;
    font-weight: 500;
    font-size: 21px;
    cursor: pointer;
    white-space: nowrap;
    overflow: hidden;
    width: 50%;

}

.fee-module-body-card {
    display: flex;
    margin-top: 30px;
    flex-wrap: wrap;
    justify-content: flex-start;

}

.fee-card-pc-home {
    background-color: #fff;
    box-shadow: 0 23px 27px 0 rgba(215,221,229,.2);
    border-radius: 16px 20px 20px 20px;
    padding-top: 26px;
    width: 165px;
    height: 138px;
    box-sizing: border-box;
    margin-bottom: 10px;
    margin-left: 14px;

}



.fee-card-pc-home .fee-card-body-long {
    color: #ff6900;
    letter-spacing: -4px;
    font-weight: 500;
    text-align: center;
    font-size: 38px;
    line-height: 48px;
}

.fee-card-pc-home .fee-card-body-short {
    color: #41ce09;
    letter-spacing: -4px;
    font-weight: 500;
    text-align: center;
    font-size: 38px;
    line-height: 48px;
}

.fee-card-pc-home .fee-card-body-none {
    color: #8d8d8d;
    letter-spacing: -4px;
    font-weight: 500;
    text-align: center;
    font-size: 38px;
    line-height: 48px;
}


.fee-card-pc-home .fee-card-body-title-big {
    font-size: 28px;
}
.fee-card-pc-home .fee-card-body-title {
    text-align: center;
    font-weight: 500;
    margin-top: 5px;
}
.w-full {
    width: 100%;
}
.relative {
    position: relative;
}

.SearchCopilot_searchContainer__K9SFC {
    position: relative;
    min-height: 118px;
    background: #fff;
    border: 1px solid #fff;
    border-radius: 14px;
    padding: 20px 0 0;
    width: 100%;
    z-index: 10;
    font-size: 14px;
}

.SearchCopilot_searchContainer__K9SFC .SearchCopilot_textarea__EPaA1 {
    padding: 0 8px 0 20px;
    width: 100%;
    display: block;
    border: none;
    height: 120px;
    /* width:1000px;height:140 */
    font-size: 18px;
    font-weight: 400;
    color: #8d8d8d;
    line-height: 20px;
    outline: none;
    resize: none;
    box-shadow: none;
    background-color: transparent;
}

.SearchCopilot_searchContainer__K9SFC textarea::placeholder {
  color: #a8a7a7;
}


.SearchCopilot_quickRight__FszXa .btn {
    background: #ff6900;
    border: 1px solid #ff6900;
    border-radius: 8px;
    color: #fff;
    font-size: 16px;
    /* 
    line-height: 40px; */
    height: 50px;
    position: absolute;
    right: 24px;
    
    text-align: center;
    text-decoration: none;
    top: 80%;
    transform: translateY(-80%);
    width: 60px;
}
.text-success{
  color: green !important;
}
</style>
